import { render, staticRenderFns } from "./myDelfi.vue?vue&type=template&id=f766ea50"
import script from "./myDelfi.vue?vue&type=script&lang=ts"
export * from "./myDelfi.vue?vue&type=script&lang=ts"
import style0 from "./myDelfi.vue?vue&type=style&index=0&id=f766ea50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports